import { createFileRoute } from "@tanstack/react-router"

import { VoxSenseOverviewView } from "@/features/voxsense/components/voxsense-overview-view"

export const Route = createFileRoute("/_shell/voxsense/")({
  component: VoxSenseOverviewView,
})
